var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let OutputNodeSettings = class OutputNodeSettings extends LitElement {
    render() {
        return html `
      <h3 class="output-node-settings__header">${msg('Output data', { id: 'outputNode.header', desc: 'Output data panel header' })}</h3>
      <div class="output-node-settings__content">
      <div class="output-node-settings__input-spacer"></div>
      ${this.nodeExecution
            ? html `
            <json-displayer .data=${this.nodeExecution.output_data}></json-displayer>
          `
            : html `<h3 class="message">${msg('No execution data available. Please run the workflow to see output data.', { id: 'outputNode.noExecutionData', desc: 'No execution data message' })}</h3>`}
      </div>
      `;
    }
};
OutputNodeSettings.styles = css `
    :host {
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .output-node-settings__header {
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      padding-bottom: 12px;
      border-bottom: 1px solid #ddd;
      background: #fff;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .output-node-settings__content {
      box-sizing: border-box;
      flex: 1;
      overflow-y: auto;
      min-height: 0;
    }

    .output-node-settings__input {
      width: 100%;
    }

    .output-node-settings__input-spacer {
      height: 12px;
    }

    .message {
      padding: 16px;
      font-size: 0.9rem;
      color: #666;
    }
  `;
__decorate([
    property({ type: Object })
], OutputNodeSettings.prototype, "nodeExecution", void 0);
OutputNodeSettings = __decorate([
    localized(),
    customElement('output-node-settings')
], OutputNodeSettings);
export { OutputNodeSettings };
//# sourceMappingURL=OutputNodeSettings.js.map